import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { SUBCONTRACTORS_RECORDS_VIEW } from 'scenes/Permissions/constants/permissions';
import {
  selectIsAdminInSelectedProject,
  selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness,
} from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { calendarOpenPreviousWeek } from '../actions/demoActions';
import { selectIsPersonalWorkCalendarMode } from '../selectors/base-work-calendar.selectors';
import {
  selectFetchedWeekNumbers,
  selectWorkSearchParamsVisibleWeeks,
} from '../selectors/workSearchParamsSelectors';
import { loadAdminCalendarFilesDataInTimeframe } from './loadAdminCalendarFilesDataInTimeframe.thunk';
import { loadAdminCalendarRecordsDataInTimeframe } from './loadAdminCalendarRecordsDataInTimeframe.thunk';
import { loadCalendarDataInTimeframe } from './loadCalendarDataInTimeframe.thunk';
import { loadSubcontractorRecordsData } from './loadSubcontractorRecordsData.thunk';
import { loadPersonalWorkCalendarData } from './my-lixani/loadPersonalWorkCalendarData.thunk';
export const setOpenPreviousWeek = createAsyncThunk(
  'workCalendar/setOpenPreviousWeek',
  async (_, { dispatch, getState }) => {
    const state = getState();

    const isAdminInSelectedProject = selectIsAdminInSelectedProject(state);

    const visibleWeeks = selectWorkSearchParamsVisibleWeeks(state);

    const fetchedWeeks = selectFetchedWeekNumbers(state);

    const isPersonalWorkCalendarMode = selectIsPersonalWorkCalendarMode(state);

    const isPermissionFromActiveBusinessToViewSubcontractorRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        SUBCONTRACTORS_RECORDS_VIEW
      );

    const weekISO =
      visibleWeeks.length > 0
        ? visibleWeeks[0]
        : dayjs().startOf('isoWeek').format();

    const prevWeek = dayjs(weekISO).subtract(1, 'week').format();

    const prevWeekNumber = dayjs(prevWeek)
      .endOf('isoWeek')
      .format('GGGG[W]WW')
      .split('W')[1];

    dispatch(calendarOpenPreviousWeek(prevWeek));

    if (!fetchedWeeks.includes(prevWeekNumber)) {
      if (isPersonalWorkCalendarMode) {
        await dispatch(loadPersonalWorkCalendarData());
      } else if (isAdminInSelectedProject) {
        await Promise.allSettled([
          dispatch(loadAdminCalendarRecordsDataInTimeframe()),
          dispatch(loadAdminCalendarFilesDataInTimeframe()),
        ]);
      } else {
        if (isPermissionFromActiveBusinessToViewSubcontractorRecords) {
          await Promise.allSettled([
            dispatch(loadSubcontractorRecordsData()),
            dispatch(loadCalendarDataInTimeframe()),
          ]);
        } else {
          await dispatch(loadCalendarDataInTimeframe());
        }
      }
    }
  }
);
